import React from 'react';
import _ from 'lodash';

import { useAppSettings_AssignedPermissionsTabQuery } from 'generated/graphql';



export interface IUser {
  id: string;
  fullName: string;
  email: string;
  roleCount: number;
}

export interface IData {
  users: IUser[];
}

export function useQuery() {
  const tuple = useAppSettings_AssignedPermissionsTabQuery({});

  return React.useMemo(
    () => {
      const data: IData = {
        users: _.map(tuple.data?.siteUsers.nodes ?? [], (user): IUser => ({
          id: user.id,
          email: user.email,
          fullName: user.fullName,
          roleCount: user.assignedRoles.length
        }))
      };

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}
